export default "dist/images/block-count-up-boxed.4c6ec66.png";